import { Component, OnInit, ViewChild, Optional, ViewContainerRef } from '@angular/core';
// import { DataTableDirective } from 'angular-datatables';
import { UserService } from '../../_services/user.service';
import { ResetpasswordComponent } from './resetpassword/resetpassword.component';
import { AddUserComponent } from './adduser/adduser.component';
import { DataTableDirective } from 'angular-datatables';
import { DialogService } from "ng2-bootstrap-modal";

@Component({
    selector: 'app-user',
    templateUrl: './user.component.html',
    styleUrls: ['./user.component.css']
})
export class UserComponent implements OnInit {

    users: any;
    searchWord: string;
    delayTimer: any;
    dtOptions: DataTables.Settings = {};
    @ViewChild(DataTableDirective)
    dtElement: DataTableDirective;

    //declare parameters object
    parameters: any = {};
    //declare callback object
    callback: any = {};
    filterBy = 2; // default get all user web

    constructor(private userService: UserService, private dialogService: DialogService) {
    }

    ngOnInit() {
        this.initDataTables();
    }

    initDataTables() {

        let self = this;
        this.dtOptions = {
            language: {
                emptyTable: "データが存在しません"
            },
            order: [[0, "desc"]],
            searching: false,
            lengthChange: false,
            serverSide: true,
            pageLength: 15,
            ajax: function (parameters, callback, settings) {
                parameters["search"]["value"] = self.searchWord || '';

                if (self.filterBy == 1) {
                    parameters["search"]["active"] = 1;
                } else if (self.filterBy == 0) {
                    parameters["search"]["active"] = 0;
                }

                //assign parameters object
                self.parameters = parameters;
                //assign callback object
                self.callback = callback;

                self.userService.gets(parameters).subscribe(result => {
                    callback({
                        draw: parameters['draw'],
                        data: result.data,
                        recordsTotal: result.data.length,
                        recordsFiltered: result.recordsTotal
                    });
                });
            },
            columns: [
                {
                    title: 'ID',
                    data: 'id',
                    name: 'id',
                    className: 'all text-justify',
                },
                {
                    title: "表示名",
                    data: "name",
                    name: "name",
                    className: "all text-justify"
                },
                {
                    title: "アカウント",
                    data: "username",
                    name: "username",
                    className: "all text-justify"
                },
                {
                    title: "メールアドレス",
                    data: function (data) {
                        return data.email != null ? data.email : '--';
                    },
                    name: "email",
                    className: "all text-justify"
                },
                {
                    title: "登録日時",
                    data: function (data) {
                        return data.created_at != null ? data.created_at : '--';
                    },
                    name: "created_at",
                    className: "all text-justify"
                },
                {
                    title: "",
                    data: "btn_is_admin_approved",
                    width: '60px',
                    className: "all text-center",
                    orderable: false
                },
                {
                    title: "",
                    data: function (d) {
                        return `<button class="btn btn-small btn-reset">パスワードを再設定する</button>`;
                    },
                    width: '120px',
                    orderable: false,
                    className: "all text-justify"
                }
            ],
            rowCallback: (row: Node, data: any[] | Object, index: number) => {
                $('.btn-reset', row).bind('click', () => {
                    self.openModalReset(data);
                });
                $('.btn-admin-approved', row).bind('click', () => {
                    self.IsAdminApproved(data);
                });
                return row;
            }
        };
    }

    valuechange(newValue) {
        this.searchWord = newValue;
        this.doSearch();
    }

    onChangeFilter(event) {
        this.filterBy = event.target.value;
        this.rerenderDataTable();
    }

    IsAdminApproved(data) {
        this.userService.updateIsAdminApproved(data).subscribe(data => {
            if (!data.error) {
                this.loadCurrentPage();
            } else {
                alert(data.message);
            }
        }, error => {
            alert(error.json().message);
        });
    }

    doSearch() {
        let self = this;
        clearTimeout(this.delayTimer);
        this.delayTimer = setTimeout(function () {
            self.rerenderDataTable();
        }, 600);
    };

    rerenderDataTable(): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw();
        });
    }

    openModalReset(data) {
        this.dialogService.addDialog(ResetpasswordComponent,
            { userId: data.id, userName: data.username });
    }

    openModalAddUser() {
        let self = this;
        this.dialogService.addDialog(AddUserComponent).subscribe((isAccess) => {
            this.loadCurrentPage();
        });
    }

    loadCurrentPage() {
        //get parameters and retrive result of current page 
        this.userService.gets(this.parameters).subscribe(result => {
            //use callback function
            this.callback({
                //retrive draw current
                draw: this.parameters['draw'],
                //retrive data of current page
                data: result.data,
                //retrive number records per page
                recordsTotal: result.data.length,
                //retrive total records
                recordsFiltered: result.recordsTotal
            });
        });
    }
}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/user/user.component.ts